import { ActivityState } from 'types/aspen/events';
import { GetStatesRespRxMsg } from 'types/aspen/socketMessages';

type FindStateByIdParams = {
  getStatesResponse: GetStatesRespRxMsg['payload'];
  stateId: string;
};

export const findStateById = ({ getStatesResponse, stateId }: FindStateByIdParams): ActivityState | null =>
  getStatesResponse.reduce<ActivityState | null>(
    (result, { states }) =>
      result || states.find((state) => state.id === stateId && state.status === 200)?.state || null,
    null,
  );

type FindFirstEventParams = {
  getStatesResponse: GetStatesRespRxMsg['payload'];
};

export const findFirstEvent = ({ getStatesResponse }: FindFirstEventParams): ActivityState | null =>
  getStatesResponse.reduce<ActivityState | null>(
    (result, { states }) => result || states.find((state) => state.status === 200)?.state || null,
    null,
  );
